define('views/components/lead/lead_list',['require','views/base/list_view','views/components/lead/lead','text!templates/components/lead/lead_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/lead/lead');

    var temp = require("text!templates/components/lead/lead_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

